import Personv2 from "./Personv2";

export default Personv2;
